import React, { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog'
import { PatientDetails } from './PatientDetails'
import { usePatient } from '../hooks/usePatient'
import { EditPatientDialog } from './EditPatientDialog'
import { PrintPatientRecordDialog } from './PrintPatientRecordDialog'
import { Button } from '../../../components/ui/button'
import { Printer, FileEdit } from 'lucide-react'

interface PatientDetailsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  patientId: string
}

export const PatientDetailsDialog: React.FC<PatientDetailsDialogProps> = ({ 
  open, 
  onOpenChange, 
  patientId 
}) => {
  const { data: patient, isLoading } = usePatient(patientId)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [printDialogOpen, setPrintDialogOpen] = useState(false)

  if (isLoading) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-[800px]">
          <div className="flex items-center justify-center h-[400px]">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
          </div>
        </DialogContent>
      </Dialog>
    )
  }

  if (!patient) return null

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-[800px]">
          <DialogHeader className="border-b border-border pb-4">
            <div className="flex justify-between items-center">
              <DialogTitle className="text-2xl font-semibold text-foreground">Patient Details</DialogTitle>
              <div className="flex gap-2">
                <Button variant="outline" size="sm" onClick={() => setPrintDialogOpen(true)}>
                  <Printer className="h-4 w-4 mr-2" />
                  Print
                </Button>
                {patient.status === 'active' && (
                  <Button variant="outline" size="sm" onClick={() => setEditDialogOpen(true)}>
                    <FileEdit className="h-4 w-4 mr-2" />
                    Edit
                  </Button>
                )}
              </div>
            </div>
          </DialogHeader>
          <div className="mt-4">
            <PatientDetails patient={patient} />
          </div>
        </DialogContent>
      </Dialog>

      <EditPatientDialog 
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        patientId={patientId}
      />

      <PrintPatientRecordDialog
        open={printDialogOpen}
        onOpenChange={setPrintDialogOpen}
        patientId={patientId}
      />
    </>
  )
}
